export default {
  namespaced: true,
  state: {
    slaSelected: null,  
    tabSelected: "helpdesk",
    tabAliasSelected:"",
    cmCentralText:null,
    catTimeSelected:null,
    cmTypeSelected:"",
    catSettingSelected:null
     
  },
  getters: {
    getSlaSelected: state => {
      return state.slaSelected
    },
    getTabSelected: state => {
      return state.tabSelected
    },
    getTabAliasSelected: state => {
      return state.tabAliasSelected
    },
    getCmCentralText: state => {
      return state.cmCentralText
    },
    getCatTimeSelected: state => {
      return state.catTimeSelected
    },
    getCmTypeSelected: state => {
      return state.cmTypeSelected
    },
    getCatSettingSelected: state => {
      return state.catSettingSelected
    },
  },
  mutations: {
    SET_SLA_SELECTED(state, sla) {
      state.slaSelected = sla
    },
    SET_TAB_SELECTED(state, tab) {
      state.tabSelected = tab
    },
    SET_TAB_ALIAS_SELECTED(state, tab) {
      state.tabAliasSelected = tab
    },
    SET_CM_CENTRAL_TEXT(state, text) {
      state.cmCentralText = text
    },
    SET_CAT_TIME_SELECTED(state, text) {
      state.catTimeSelected = text
    },
    SET_CM_TYPE_SELECTED(state, text) {
      state.cmTypeSelected = text
    },
    SET_CAT_SETTING_SELECTED(state, text) {
      state.catSettingSelected = text
    },
  },
  

  
}


